import { helper as buildHelper } from '@ember/component/helper';
export function getFromMap([key, map]) {
  return map.get(key);
}
export default buildHelper(getFromMap);